import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { isFunction } from '@elliemae/ds-utilities/utils';
import FocusGroup from './FocusGroup.js';
import FocusGroupContext from './FocusGroupContext.js';
import 'hotkeys-js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noop = function noop() {
  return null;
};

var FocusGroupProvider = /*#__PURE__*/function (_Component) {
  _inherits(FocusGroupProvider, _Component);

  var _super = _createSuper(FocusGroupProvider);

  function FocusGroupProvider(props) {
    var _this;

    _classCallCheck(this, FocusGroupProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "activated", false);

    _this.focusGroup = new FocusGroup(props);
    props.onFocusGroupSet(_assertThisInitialized(_this));
    _this.actions = {
      activate: _this.activate.bind(_assertThisInitialized(_this)),
      deactivate: _this.deactivate.bind(_assertThisInitialized(_this)),
      register: _this.focusGroup.register,
      unregister: _this.unregister.bind(_assertThisInitialized(_this)),
      focusFirst: _this.focusGroup.focusFirst,
      focusLast: _this.focusGroup.focusLast,
      focusItemByIndex: _this.focusItemByIndex.bind(_assertThisInitialized(_this)),
      focusItemByNode: _this.focusItemByNode.bind(_assertThisInitialized(_this)),
      focus: _this.focusGroup.focusCurrent,
      isGroupActive: _this.focusGroup.isGroupActive,
      focusNext: _this.focusGroup.focusNext,
      focusPrevious: _this.focusGroup.focusPrevious
    };
    return _this;
  }

  _createClass(FocusGroupProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var autoFocusOnMount = this.props.autoFocusOnMount;
      this.activate();

      if (autoFocusOnMount) {
        setTimeout(function () {
          _this2.actions.focusFirst();
        }, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deactivate();
    }
  }, {
    key: "activate",
    value: function activate() {
      var onActivate = this.props.onActivate;
      this.focusGroup.activate();
      this.activated = true;
      if (isFunction(onActivate)) onActivate();
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      var onExitFocusGroup = this.props.onExitFocusGroup;
      this.activated = false;
      this.focusGroup.deactivate();

      if (isFunction(onExitFocusGroup)) {
        onExitFocusGroup();
      }
    }
  }, {
    key: "register",
    value: function register(item) {
      this.focusGroup.register(item);
    }
  }, {
    key: "unregister",
    value: function unregister(item) {
      this.focusGroup.unregister(item);
    }
  }, {
    key: "focusItemByIndex",
    value: function focusItemByIndex(index) {
      var _this3 = this;

      if (!this.activated) this.activate();
      setTimeout(function () {
        _this3.focusGroup.focusByIndex(index);
      }, 200);
    }
  }, {
    key: "focusItemByNode",
    value: function focusItemByNode(node) {
      if (!this.activated) this.activate();
      var index = this.focusGroup.getItemIndexByNode(node);
      this.focusItemByIndex(index);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(FocusGroupContext.Provider, {
        value: this.actions
      }, children);
    }
  }]);

  return FocusGroupProvider;
}(Component);

_defineProperty(FocusGroupProvider, "defaultProps", {
  exitWhenNoPrevious: false,
  exitWhenNoNext: false,
  keyBindings: {},
  onFocus: noop,
  onExitFocusGroup: noop,
  onFocusPreviousGroup: noop,
  onFocusNextGroup: noop,
  onFocusGroupSet: noop
});

export default FocusGroupProvider;
//# sourceMappingURL=FocusGroupManager.js.map
